var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('SearchForm',{attrs:{"value":_vm.text},on:{"change":_vm.handleSearch}}),_vm._v(" "),(_vm.results)?_c('SearchResults',{attrs:{"results":_vm.results,"term":_vm.text}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }